module.exports = __webpack_public_path__ + "static/img/线上续方@3x.ca11562.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/线上续方@3x.png
// module id = 320
// module chunks = 379 380